import React, { forwardRef } from 'react';
import styles from './start-menu-content.module.scss';
import { WindowItem } from '../../../common/interfaces/os-resume-interface';

interface StartMenuProps {
  openWindow: (id: string) => void;
  onShutdown: () => void;
  availableWindowsModals: Map<string, WindowItem>;
}

const StartMenu = forwardRef<HTMLDivElement, StartMenuProps>(
  ({ openWindow, onShutdown, availableWindowsModals }, ref) => {
    return (
      <div ref={ref} className={styles.startMenu}>
        <div className={styles.startHeader}>Resume XP</div>

        <div className={styles.menuItems}>
          {[...(availableWindowsModals?.values() || [])].map((win) => (
            <button onClick={() => openWindow(win.id)} key={win.id}>
              {win.Icon}
              <span>{win.title}</span>
            </button>
          ))}
        </div>

        <div className={styles.shutdownArea}>
          <button className={styles.shutdownBtn} onClick={onShutdown}>
            Shut Down
          </button>
        </div>
      </div>
    );
  },
);

StartMenu.displayName = 'StartMenu';

export default StartMenu;
